"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
var carousel_1 = require("./carousel");
exports.CarouselNavigation = function () {
    var _a = react_1.useContext(carousel_1.CarouselContext), _b = _a.state, current = _b.current, count = _b.count, goTo = _a.goTo, prev = _a.prev, next = _a.next;
    var mapper = Array.from(Array(count));
    var indicators = mapper.map(function (_, i) {
        var isActive = current === i;
        return (react_1.default.createElement(creator_ui_1.Indicator, { isActive: isActive, onClick: function () { return goTo(i); }, key: "slide-indicator-" + i }));
    });
    return (react_1.default.createElement(creator_ui_1.Flexbox, { justifyContent: "center", p: "10px" },
        react_1.default.createElement(creator_ui_1.Button, { onClick: prev }, "Prev"),
        react_1.default.createElement(creator_ui_1.Flexbox, { as: "ul" }, indicators),
        react_1.default.createElement(creator_ui_1.Button, { onClick: next }, "Next")));
};
